import { AxiosInstance, AxiosError, InternalAxiosRequestConfig } from "axios";
import { getAccessToken, endSession } from "./tokenAccessor";

export const attachAuthInterceptor = (client: AxiosInstance): void => {
  client.interceptors.request.use(
    async (config: InternalAxiosRequestConfig) => {
      const token = await getAccessToken();
      config.headers.Authorization = `Bearer ${token}`;
      return config;
    },
    (error) => Promise.reject(error)
  );

  client.interceptors.response.use(
    (response) => response,
    async (error: AxiosError) => {
      const originalRequest = error.config as InternalAxiosRequestConfig & {
        _retried?: boolean;
      };

      // On 401, attempt one retry with a fresh token.
      // 403 means authenticated but not authorized (e.g. missing org context),
      // so we don't retry or log out blindly to avoid loops.
      if (
        (error.response?.status === 401) &&
        originalRequest &&
        !originalRequest._retried
      ) {
        originalRequest._retried = true;

        try {
          const token = await getAccessToken();
          originalRequest.headers.Authorization = `Bearer ${token}`;
          return client(originalRequest);
        } catch {
          // Refresh failed — end session through the SDK (clears cookies + tokens)
          endSession();
          return Promise.reject(error);
        }
      }

      // Already retried and still 401 — end session through the SDK
      if (error.response?.status === 401) {
        endSession();
      }

      return Promise.reject(error);
    }
  );
};
